@file:OptIn(InternalResourceApi::class)

package waifupics.modules.features.gallery.generated.resources

import kotlin.OptIn
import kotlin.String
import kotlin.collections.MutableMap
import org.jetbrains.compose.resources.InternalResourceApi
import org.jetbrains.compose.resources.ResourceContentHash
import org.jetbrains.compose.resources.ResourceItem
import org.jetbrains.compose.resources.StringArrayResource

private const val MD: String =
    "composeResources/waifupics.modules.features.gallery.generated.resources/"

@delegate:ResourceContentHash(-64_159_167)
internal val Res.array.gallery_months: StringArrayResource by lazy {
      StringArrayResource("string-array:gallery_months", "gallery_months", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 10, 87),
      ))
    }

@InternalResourceApi
internal fun _collectCommonMainArray0Resources(map: MutableMap<String, StringArrayResource>) {
  map.put("gallery_months", Res.array.gallery_months)
}
